export default () => ({
  isLoading: false,
  hasError: false,
  releases: [],
  pageInfo: {},
});
